import { useSupportArticles } from "@src/appV2/HelpCenter/api/useSupportArticles";
import { APP_V2_USER_EVENTS, useLogEffect } from "@src/appV2/lib/analytics";
import { useIsMobile } from "@src/appV2/redesign/AppLayout/useResponsive";
import { useShouldRedirectToDailyView } from "@src/appV2/redesign/DailyView/hooks/useShouldRedirectToDailyView";
import { getLocation } from "@src/appV2/redesign/utils/routes";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { ALL_SUPPORT_ARTICLES_CATEGORY } from "./constants";
import { HelpCenterView } from "./HelpCenterView";
import { getFilteredSupportArticleGroups, getSupportArticleCategories } from "./utils";

export function HelpCenterContainer() {
  const history = useHistory();
  const isMobile = useIsMobile();
  const shouldRedirectToDailyView = useShouldRedirectToDailyView();
  const { data, isError, isLoading, isSuccess } = useSupportArticles();
  const supportArticles = useMemo(() => data?.data ?? [], [data?.data]);
  const categories = useMemo(() => getSupportArticleCategories(supportArticles), [supportArticles]);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(ALL_SUPPORT_ARTICLES_CATEGORY);

  useEffect(() => {
    if (!categories.includes(selectedCategory)) {
      setSelectedCategory(ALL_SUPPORT_ARTICLES_CATEGORY);
    }
  }, [categories, selectedCategory]);

  const articleGroups = useMemo(
    () => getFilteredSupportArticleGroups({ supportArticles, searchQuery, selectedCategory }),
    [supportArticles, searchQuery, selectedCategory]
  );

  useLogEffect(APP_V2_USER_EVENTS.HELP_CENTER_PAGE_VIEWED);

  const handleBack = useCallback(() => {
    if (history.length > 1) {
      history.goBack();
      return;
    }

    history.push(getLocation(shouldRedirectToDailyView ? "schedule" : "facilityDashboard"));
  }, [history, shouldRedirectToDailyView]);

  return (
    <HelpCenterView
      articleGroups={articleGroups}
      categories={categories}
      isError={isError}
      isLoading={isLoading}
      isMobile={isMobile}
      isSuccess={isSuccess}
      searchQuery={searchQuery}
      selectedCategory={selectedCategory}
      supportArticles={supportArticles}
      onBack={handleBack}
      onSearchChange={setSearchQuery}
      onSelectCategory={setSelectedCategory}
    />
  );
}
